import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'CarsListPage',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/CarsListPage.vue'),
  },
  {
    path: '/manage',
    name: 'ManagePage',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/ManagePage.vue'),
  },
  {
    path: '/user-management',
    name: 'UserManagement',
    component: () => import(/* webpackChunkName: "auth" */ '@/views/UserManagement.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
